<template>
    <div>
        <p
            class="feed-carousel-name"
            :class="hasConflicts?'show-conflict-title': ''"
        >
            {{ feedResource.name }}
        </p>
        <div
            v-if="filteredFeeds.length > 0 && !loading && isDisplayed"
        >
            <carousel
                :feeds="feedsToDisplay"
            ></carousel>
        </div>
        <div
            v-else
            class="no-item"
        >
            No Feed
        </div>
    </div>
</template>

<script>
import Carousel from './carousel.vue';
import moment from 'moment';
import { mapGetters } from 'vuex';
export default {

    name: 'feed-carousel',

    components:{
        Carousel
    },

    props:{
        feedResource:{
            type: Object,
            required: true
        },
        feeds:{
            type: Array,
            required: true
        },
        activeNames:{
            type: Array,
            required: true
        },
        name:{
            type: String,
            required: true
        },
        filteredEvents:{
            type: Array,
            required: true
        }
    },

    data () {
        return {
            filteredFeedsWithConflicts: [],
            loading: true,
            hasConflicts: false,
        };
    },

    computed:{
        ...mapGetters([
            'selectedEntitiesForFilter',
            'selectedUniversesForFilter',
            'selectedEventsForFilter',
        ]),
        filteredFeeds(){
            return this.feeds.filter((feed) => feed.feed_resource_uid === this.feedResource.uid);
        },
        feedsToDisplay(){
            let feeds = [...this.filteredFeedsWithConflicts];
            if(this.selectedEntitiesForFilter.length > 0){
                feeds = feeds.filter(
                    feed => this.selectedEntitiesForFilter
                        .includes(feed.scopes.entity_uid)
                );
            }
            if(this.selectedUniversesForFilter.length > 0){
                /*
                    No direct link between feed and universe so we return all feeds based on relation between event and universe
                */
                let eventUids = this.filteredEvents.map(event => event.uid);
                feeds = feeds.filter(
                    feed => eventUids.includes(feed.event_uid)
                );
            }
            if(this.selectedEventsForFilter.length > 0){
                feeds = feeds.filter(
                    feed => this.selectedEventsForFilter
                        .includes(feed.event_uid)
                );
            }
            return feeds;
        },
        isDisplayed(){
            if(this.activeNames.length > 0){
                return this.activeNames.includes(this.name);
            }
            return false;
        }
    },

    watch: {
        filteredFeeds: {
            handler(val) {
                if(val.length > 0){
                    this.addConflicts();
                } else {
                    this.$set(this, 'filteredFeedsWithConflicts', []);
                }
            },
            deep: true
        }
    },

    mounted(){
        this.$nextTick(() => {
            this.addConflicts();
        });
    },

    methods:{
        addConflicts(){
            this.loading = true;
            let feeds = [...this.filteredFeeds];
            for (let i = 0; i < feeds.length; i++) {
                feeds[i].conflicts = [];
                const startDateI = feeds[i].confirmed
                    ? moment.utc(feeds[i].confirmed_start_date).subtract(15, 'minutes').toISOString()
                    : moment.utc(feeds[i].start_date).subtract(15, 'minutes').toISOString();
                const endDateI = feeds[i].confirmed
                    ? moment.utc(feeds[i].confirmed_end_date).toISOString()
                    : moment.utc(feeds[i].end_date).toISOString();

                for (let j = 0; j < feeds.length; j++) {
                    if (i !== j) {
                        if(!feeds[j].conflicts){
                            feeds[j].conflicts = [];
                        }
                    // Check if the periods overlap
                        const startDateJ = feeds[j].confirmed
                            ? moment.utc(feeds[j].confirmed_start_date).subtract(15, 'minutes').toISOString()
                            : moment.utc(feeds[j].start_date).subtract(15, 'minutes').toISOString();
                        const endDateJ = feeds[j].confirmed
                            ? moment.utc(feeds[j].confirmed_end_date).toISOString()
                            : moment.utc(feeds[j].end_date).toISOString();

                        if (
                            moment.utc(startDateI).isSameOrBefore(endDateJ) &&
                            moment.utc(startDateJ).isSameOrBefore(endDateI)
                        ) {
                            if(!feeds[i].conflicts.includes(feeds[j].name)){
                                feeds[i].conflicts.push(feeds[j].name);
                            }
                            if(!feeds[j].conflicts.includes(feeds[i].name)){
                                feeds[j].conflicts.push(feeds[i].name);
                            }
                            this.$set(this, 'hasConflicts', true);
                        }
                    }
                }
            }
            if(this.hasConflicts){
                this.$emit('has-conflicts', {
                    resourceName: this.feedResource.name,
                    hasConflict:true,
                }
            );
            }else{
                this.$emit('has-conflicts', {
                    resourceName: this.feedResource.name,
                    hasConflict:false,
                }
            );
            }
            this.$set(this, 'filteredFeedsWithConflicts', feeds);
            this.loading = false;
        },
    }

};
</script>

<style lang="scss">
.feed-carousel-name{
    text-transform: uppercase;
    font-size: 17px;
    color: #BBBBBB;
}
.show-conflict-title{
    color: #f35858;
}
</style>


// WEBPACK FOOTER //
// src/components/page/FeedResourcesOverview/feed-carousel.vue